import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RequestReset, Reset} from '../models/user';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {AuthResources} from './auth-resources';
import {catchError, map} from 'rxjs/operators';
import {LanguageService} from '../../core/services/language.service';
import {PasswordResetErrorSelector} from './request-password-reset-error-selector';

@Injectable()
export class PasswordResetService {

    private passwordResetSelector: PasswordResetErrorSelector;

    constructor(private http: HttpClient, private languageService: LanguageService) {
        this.passwordResetSelector = new PasswordResetErrorSelector(this.languageService);
    }

    /**
     *
     * @return Observable of type boolean returns success
     */
    requestReset({ email, captcha }: RequestReset): Observable<boolean> {
        const resourceUrl = environment.rest_backend + AuthResources.requestPasswordResetResource;

        const requestBody = {
            email,
            template: 'email_reset'
        };

        return this.http.put(resourceUrl, requestBody, {
            withCredentials: false,
            headers: {
                'h-captcha-response': captcha
            },
        }).pipe(
            map(resp => <boolean>resp),
            catchError(this.passwordResetSelector.requestPasswordResetErrorSelector)
        );
    }

    /**
     *
     * @return Observable of type boolean returns success
     */
    reset({ email, newPassword, resetToken }: Reset): Observable<boolean> {
        const resourceUrl = environment.rest_backend + AuthResources.passwordResetResource;

        const requestBody = {
            email,
            newPassword,
            resetToken
        };

        return this.http.post(resourceUrl, requestBody, {
            withCredentials: false
        }).pipe(
            map(resp => <boolean>resp),
            catchError(this.passwordResetSelector.passwordResetErrorSelector)
        );
    }

}
